import { fetchSsdAdminSettings } from "./SsdSettingsNetworkAPI";

export const SsdSettingsReducer = (state, action) => {
  switch (action.type) {
    case "RECEIVED_ADMIN_SETTINGS":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          adminSettings: {
            ...action.data,
          },
        },
      };
    case "FETCH_ADMIN_SETTINGS":
      fetchSsdAdminSettings(action.data.dispatcher);
      return state;

    case "UPDATE_ADMIN_SETTINGS":
      return {
        ...state,
        showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
        messageToDisplay: action.data.messageToDisplay,
        settingsData: {
          ...state.settingsData,
          adminSettings: {
            ...action.data.adminSettings,
          },
        },
      };

    case "SHOW_UPDATE_PLAN_RESPONSE_MODAL":
      return {
        ...state,
        showUpdatePlanResponseModal: action.modalState,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdSettingsReducer.js